import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik, useField } from "formik";
import * as Yup from "yup";
import { IMG } from "../../../assets";
import { toast } from "react-toastify";
import { CONTACT } from "../../../api/Contact";

import formatPhoneNumber from "../../../utils/formatPhoneNumber";
export default function Contact({ links }) {
  const [data] = useState({
    name: "",
    place: "",
    mobile: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    place: Yup.string().required("Required"),
    mobile: Yup.number()
      .required("Required")
      .min(3, "Min 3 numbers are required"),
    email: Yup.string().required("Required"),
    message: Yup.string().required("Required"),
  });

  const MyTextArea = ({ label, ...props }) => {
    const [field] = useField(props);
    return (
      <>
        <textarea
          className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
          {...field}
          {...props}
        />
      </>
    );
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    var request = {
      name: values.name,
      place: values.place,
      mobile: values.mobile,
      email: values.email,
      message: values.message,
      isViewed: false,
      isPurged: false,
    };
    try {
      const res = await CONTACT.ADD(request);
      if (res.status === 200) {
        setLoading(false);
        toast.success("Request sent successfully");
      } else {
        setLoading(false);
        toast.error("Failed to create new stage");
        throw new Error("failed to create an topic");
      }
    } catch (error) {
      setLoading(false);
      // console.log("error", error);
    }
  };
  const mapSrc =
    links !== null && links !== undefined
      ? links.mapIframe
      : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d744.364992040313!2d76.22095096682472!3d10.034846901400227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0813b5962b2635%3A0xf26b51112949e2e3!2sJoy%20Electricals%20%2C%20Plumbing%20and%20Hardwares!5e0!3m2!1sen!2sin!4v1744095608888!5m2!1sen!2sin";

  return (
    <div className="h-auto w-full  flex justify-center items-center font-bubbles">
      <div className="max-w-screen-2xl w-[80%] h-[90%] grid grid-cols-4 mt-20 gap-10">
        <div className="col-span-4 lg:col-span-2 ">
          <div className=" w-full h-auto px-6.5">
            <p className="text-3xl 2xl:text-5xl">
              Hi, We&apos;re happy to help you!
            </p>
            <p className="2xl:text-xl text-base mt-2">
              Please enter details so we can reach out now
            </p>
          </div>

          <Formik
            initialValues={data}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleSubmit(values);
            }}
          >
            <Form className="grid grid-cols-1 sm:grid-cols-1 mt-10 gap-5 px-6.5">
              <div className="flex flex-col  xl:flex-row">
                <div className="w-full">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Your Name
                  </label>
                  <Field
                    placeholder="Enter Your Name"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="name"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="name"
                  />
                </div>
              </div>
              <div className=" flex flex-col  xl:flex-row">
                <div className="w-full">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Your Place
                  </label>
                  <Field
                    placeholder="Enter Your Place"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="place"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="place"
                  />
                </div>
              </div>
              <div className=" flex flex-col  xl:flex-row">
                <div className="w-full">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Your Mobile
                  </label>
                  <Field
                    placeholder="Enter Your Mobile No."
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="mobile"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="mobile"
                  />
                </div>
              </div>
              <div className=" flex flex-col  xl:flex-row">
                <div className="w-full">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Your Email
                  </label>
                  <Field
                    placeholder="Enter Your Email"
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    name="email"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="email"
                  />
                </div>
              </div>
              <div className=" flex flex-col  xl:flex-row">
                <div className="w-full">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Message
                  </label>
                  <MyTextArea
                    name="message"
                    rows="4"
                    placeholder="Please explain your enquiry"
                  />
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="message"
                  />
                </div>
              </div>
              <div className=" flex flex-col  xl:flex-row">
                <div className="w-full h-full flex justify-end items-end">
                  <button
                    type="submit"
                    className="flex w-1/2 rounded-full justify-center  bg-event p-3 font-medium text-gray"
                  >
                    {loading ? (
                      <div className="flex h-auto items-center justify-center ">
                        <div className="h-6 w-6 animate-spin rounded-full border-4 border-solid border-white border-t-transparent"></div>
                      </div>
                    ) : (
                      "Submit Now >"
                    )}
                  </button>
                </div>
              </div>
            </Form>
          </Formik>
        </div>
        {links !== null && links !== undefined && (
          <div className="flex flex-col justify-center col-span-4 lg:col-span-2 ">
            <div className="bg-white h-auto flex items-center shadow-xl w-full p-2 rounded-xl mt-10">
              <div className="bg-event h-[50px] w-[50px] flex justify-center items-center rounded-xl">
                <img className="w-10 h-10" src={IMG.phone} alt="" />
              </div>
              <div className=" w-[80%] h-auto ml-5 flex flex-col">
                <a
                  href={`tel:+91${links.phone1}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" font-bold text-2xl font-bubbles"
                >
                  +91{" "}
                  {links !== null
                    ? formatPhoneNumber(links.phone1)
                    : "00000 00000"}
                </a>
                <a
                  href={`tel:+91${links.phone2}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" font-bold text-2xl font-bubbles"
                >
                  +91{" "}
                  {links !== null
                    ? formatPhoneNumber(links.phone2)
                    : "00000 00000"}
                </a>
              </div>
            </div>
            <div className="bg-white h-auto flex items-center shadow-xl w-full p-2 rounded-xl mt-10">
              <div className="bg-event h-[50px] w-[50px] flex justify-center items-center rounded-xl">
                <img className="w-10 h-10" src={IMG.email} alt="" />
              </div>
              <div className=" w-[80%] h-auto ml-5 flex flex-col">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`mailto:${links.mail}`}
                  className=" font-bold text-lg sm:text-2xl font-bubbles"
                >
                  {links !== null ? links.mail : "encoreevents.in"}
                </a>
              </div>
            </div>
            <div className="bg-white h-auto flex items-center shadow-xl w-full p-2 rounded-xl mt-10">
              <div className="bg-event h-[50px] w-[50px] flex justify-center items-center rounded-xl">
                <img className="w-10 h-10" src={IMG.location} alt="" />
              </div>
              <div className=" w-[80%] h-auto ml-5 flex flex-col">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={links.locLink}
                  className=" font-bold text-2xl font-bubbles"
                >
                  {links !== null ? links.locName : "Encore Events"}
                </a>
              </div>
            </div>
            <div className="bg-white h-auto flex items-center shadow-xl w-full p-2 rounded-xl mt-10">
              <div className="bg-event h-[50px] w-[50px] flex justify-center items-center rounded-xl">
                <img className="w-10 h-10" src={IMG.insta} alt="" />
              </div>
              <div className=" w-[80%] h-auto ml-5 flex flex-col">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={links.instaLink}
                  className=" font-bold text-2xl font-bubbles"
                >
                  {links.instaName}
                </a>
              </div>
            </div>
            {/* <div className="bg-white h-auto flex items-center shadow-xl w-full p-2 rounded-xl mt-10">
              <div className="bg-event h-[50px] w-[50px] flex justify-center items-center rounded-xl">
                <img className="w-10 h-10" src={IMG.twitter} alt="" />
              </div>
              <div className=" w-[80%] h-auto ml-5 flex flex-col">
                <a
                target="_blank"
            rel="noopener noreferrer"
                  href="tel:+917356693134"
                  className=" font-bold text-2xl font-bubbles"
                >
                  Encore Events
                </a>
              </div>
            </div> */}
            <div className="bg-white h-auto flex items-center shadow-xl w-full p-2 rounded-xl mt-10">
              <div className="bg-event h-[50px] w-[50px] flex justify-center items-center rounded-xl">
                <img className="w-10 h-10" src={IMG.fb} alt="" />
              </div>
              <div className=" w-[80%] h-auto ml-5 flex flex-col">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={links.fbLink}
                  className=" font-bold text-2xl font-bubbles"
                >
                  {links.fbName}
                </a>
              </div>
            </div>
          </div>
        )}
        <div className="col-span-4">
          <div style={{ width: "100%", height: "400px" }}>
            <iframe
              title="Google Map"
              src={mapSrc}
              width="100%"
              height="100%"
              style={{
                border: 0,
                borderRadius: "20px",
                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.25)",
              }}
              allowFullScreen=""
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
